import React from "react";
import classnames from "classnames";
import "./FormMessage.scss";

function renderMessages(messages) {
  if (typeof messages == "string") {
    return messages;
  }
  return (
    <ol>
      {messages.map(message => (
        <li>{message}</li>
      ))}
    </ol>
  );
}

const FormMessage = ({ messages, color, children, className }) => {
  let content;

  if (messages && messages.length != 0) {
    content = renderMessages(messages);
  } else if (children) {
    content = children;
  } else {
    return null;
  }

  return (
    <div className={classnames("form-message", color, className)}>
      {content}
    </div>
  );
};

export default FormMessage;
